export default __webpack_public_path__ + "static/media/thumbnail-w-chair.e95cbc2b.png";